import React, {useState, useCallback, useLayoutEffect} from "react";
import HttpAction from "modules/utils/HttpAction";

const ParticipantContext = React.createContext({
  state: { 
    userInfo : [],
    userItems: [],
    user: {},
   userListAll: [],
   joinContestList: [],
   endContestList: [],
      tooltipInfo : {},
   introduce: '',
      activeInfo: {}
   },
  actions: {
      getUserListAll: () => {},
      getUserList : () => {},
      listCheck : () => {},
      getJoinContest: () => {},
      getIntroduce: () => {},
      addIntroduce: () => {},
      updateIntroduce: () => {},
      getActive: () => {},
      getUserInfo: () => {},
  },
});

const { Provider } = ParticipantContext;

const ParticipantProvider = ({children}) => {
    // const [userInfo, setUserInfo] = useState([]); // 역할 리스트 데이터
    const [userListAll, setUserListAll] = useState([])
    const [userInfo, setUserInfo] = useState({responsePage:{}, listData:[]}); // 역할 리스트 데이터
    const [user, setUser] = useState();
    const [userItems, setUserItems] = useState([]);
    const [joinContestList, setJoinContestList] = useState([]);
    const [endContestList, setEndContestList] = useState([]);
    const [introduce, setIntroduce] = useState(''); // 마이페이지 나의소개
    const [activeInfo, setActiveInfo] = useState({});
    const [tooltipInfo, setTooltipInfo] = useState({
        text : '',
        status: false
    })

    //리스트체크 테스트
    const listCheck = (stateType, toggleAllFlg, checkedValue, index) => {
      
      const state = {
        'USER' : userInfo
      }[stateType];

      const setFunc = {
        'USER' : setUserInfo
      }[stateType];

      const temp = { ...state };
          const tempList = [...temp.listData];

          if (toggleAllFlg) {
              tempList.forEach(e => {
                  e.checkFlg = checkedValue;
              })
          } else {
              tempList[index].checkFlg = checkedValue;
          }

          temp.listData = tempList;
          setFunc(temp);
    }

     // 사용자 전체 조회
     const getUserInfo = useCallback(() => {
        HttpAction({
            url: "/member/participant",
            method: "get",
        }).then((res) => {
            if (res.code === 200) {
                console.log('res', res)
                setUser(res.data)
            } else {
                console.log("ERR")
            }
        }).catch(error => {
            console.log("---->",error.response)
            sessionStorage.removeItem("jwt");
            sessionStorage.removeItem("userId");
            sessionStorage.removeItem("isAdmin");
            sessionStorage.removeItem("loginid");
            let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
            // document.location.href = "/main"
        });
    }, []);

    // 마이페이지 참가자 활동 정보 조회
    const getActive = useCallback((mberId) => {
        HttpAction({
            url: "/member/participant/active",
            method: "get",
            params: {
                mberId: mberId
            }
        }).then((res) => {
            if (res.code === 200) {
                setActiveInfo(res.data)
            } else {
                console.log("ERR")
            }
        }).catch(error => {
            console.log("---->",error.response)
            sessionStorage.removeItem("jwt");
            sessionStorage.removeItem("userId");
            sessionStorage.removeItem("isAdmin");
            sessionStorage.removeItem("loginid");
            let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
            // document.location.href = "/main"
        });
    }, [])

    // 사용자 전체 조회
    const getUserListAll = useCallback(contestId => {
        HttpAction({
            url: "/member/user/list",
            method: "get",
            params: {
                contestId: contestId && contestId
            }
        }).then((res) => {
            if (res.code === 200) {
                setUserListAll(res.data)
            } else {
                console.log("ERR")
            }
        }).catch(error => {
            console.log("---->",error.response)
            sessionStorage.removeItem("jwt");
            sessionStorage.removeItem("userId");
            sessionStorage.removeItem("isAdmin");
            sessionStorage.removeItem("loginid");
            let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
            // document.location.href = "/main"
        });
    }, []);

    //컴포넌트에서 공통으로 사용하는 목록
    const getUserList = useCallback((requestPage = { page: 1, records: 10 })=>{
      HttpAction({
          url: '/admin/user/list', method: 'get', params: {...requestPage}})
      .then((res) => {
          if(res.code === 200) {
          const pageResult = {};
          const userArr = [];

          pageResult.number = res.data.pageNum;
          pageResult.first = res.data.isFirstPage;
          pageResult.last = res.data.isLastPage;
          pageResult.totalPages = res.data.pages;

          res.data.list.forEach(e => {
              let userObj = { ...e, checkFlg: false };
              userArr.push(userObj);
          })
              setUserInfo({ responsePage: pageResult, listData: userArr });
          }else {
            // alert("사용자 리스트 조회에 실패했습니다.")
          }
      }).catch(err => {
        // console.log('유저 리스트 로딩에 문제가 발생했습니다');
            console.error(err);
          sessionStorage.removeItem("jwt");
          sessionStorage.removeItem("userId");
          sessionStorage.removeItem("isAdmin");
          sessionStorage.removeItem("loginid");
          let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
          // document.location.href = "/main"
    })
  } ,[]);

    const getUsers = useCallback((mberId) => {
        HttpAction({
          url: '/member/participant',
          method: "get",
            mberId: mberId
        }).then((res) => {
          if (res.code === 200) {
            setUserItems(res.data);
          } else {
            alert("사용자 로딩에 실패했습니다.");
          }
        }).catch(e => {
            // alert(e)
            sessionStorage.removeItem("jwt");
            sessionStorage.removeItem("userId");
            sessionStorage.removeItem("isAdmin");
            sessionStorage.removeItem("loginid");
            let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
            // document.location.href = "/main"
        });
      }, []);

    // 참여중인 컨테스트 조회
    const getJoinContest = useCallback((params) => {
        HttpAction({
            url: "/member/participant/joincontest",
            method: "get",
            params: {
                mberId: params && params.mberId,
                page: params && params.page,
                records: params && params.records,
                useFlg: params && params.useFlg
            }
        }).then((res) => {
            if (res.code === 200) {
                if(params && params.useFlg === 'Y') {
                    setJoinContestList(res.data);
                } else {
                    setEndContestList(res.data)
                }

            } else {
                console.log("Error", res)
            }
        }).catch(e => {
            // alert(e)
            sessionStorage.removeItem("jwt");
            sessionStorage.removeItem("userId");
            sessionStorage.removeItem("isAdmin");
            sessionStorage.removeItem("loginid");
            let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
            // document.location.href = "/main"
        });
    }, []);


    // 마이페이지 자기소개 조회
    const getIntroduce = useCallback((mberId ) => {
        HttpAction({
            url: "/member/participant/introduce",
            method: "get",
            params: {
                mberId : mberId
            }
        }).then((res) => {
            if (res.code === 200) {
                setIntroduce(res.data);
            } else {
                console.log("error",)
            }
        }).catch(e => {
            // alert(e)
            sessionStorage.removeItem("jwt");
            sessionStorage.removeItem("userId");
            sessionStorage.removeItem("isAdmin");
            sessionStorage.removeItem("loginid");
            let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
            // document.location.href = "/main"
        });
    }, []);


    // 마이페이지 자기소개 작성
    const addIntroduce = useCallback((params ) => {
        HttpAction({
            url: "/member/participant/introduce",
            method: "post",
            params: {
                mberId : params&&params.mberId,
                introduceContent : params&&params.introduceContent,
            }
        }).then((res) => {
            if (res.code === 200) {
                getIntroduce(params&&params.mberId)
                setTooltipInfo({
                    text: '나의 소개가 등록되었습니다.',
                    status: true
                })
            } else {
                console.log("error", res.code);
            }
        }).catch(e => {
            // alert(e)
            sessionStorage.removeItem("jwt");
            sessionStorage.removeItem("userId");
            sessionStorage.removeItem("isAdmin");
            sessionStorage.removeItem("loginid");
            let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
            // document.location.href = "/main"
        });
    }, []);

    // 마이페이지 자기소개 수정
    const updateIntroduce = useCallback((params ) => {
        HttpAction({
            url: "/member/participant/introduce",
            method: "put",
            params: {
                mberId : params&&params.mberId,
                introduceContent : params&&params.introduceContent,
            }
        }).then((res) => {
            if (res.code === 200) {
                getIntroduce(params&&params.mberId)
                setTooltipInfo({
                    text: '나의 소개가 수정되었습니다.',
                    status: true
                })
            } else {
                console.log("error", res.code);
            }
        }).catch(e => {
            // alert(e)
            sessionStorage.removeItem("jwt");
            sessionStorage.removeItem("userId");
            sessionStorage.removeItem("isAdmin");
            sessionStorage.removeItem("loginid");
            let date = new Date(); date.setDate(date.getDate() - 100); document.cookie = "jwt" + "=;Expires=" + date.toUTCString() + ";path=/;domain=" + `${process.env.REACT_APP_DOMAIN_URL}` + ";";
            // document.location.href = "/main"
        });
    }, []);



    
      useLayoutEffect(() => {
        if (sessionStorage.getItem("jwt") !== null) {
          getUserList();
        }

      }, []);

    const value = {
        state: {
            userListAll,
            userInfo,
            userItems,
            joinContestList,
            endContestList,
            introduce,
            activeInfo,
            user,
            tooltipInfo
        },
        actions: {
            getUserListAll,
            getUserList,
            getUsers,
            listCheck,
            getJoinContest,
            getIntroduce,
            addIntroduce,
            updateIntroduce,
            getActive,
            getUserInfo,
            setTooltipInfo
        },
    };

    return (
      <Provider value={value}>
      {children}
      </Provider>
    )
};

export { ParticipantProvider, ParticipantContext };
